//@ts-check
import Box from "@mui/material/Box";
import {
  PAGE_TEXT_LOADING_STATE,
  SOCKET_OPERATIONS,
} from "../services/socketoOperations";
import useAdvanceStoryStore from "../store/AdvanceStoryStore";
import React, { useState } from "react";
import { TextFieldWithSpinner } from "./TextEditor/TextFieldWithSpinner";
import { ModernCollapsible } from "./Collapsible/ModernCollapsible";
import { TransparentButton } from "./Button/TransparentButton";
import { DialogWrapper } from "./Dialog";
import CharacterForm from "./Characters/AddCharacterDialog/characterForm";
import characterStore from "../store/CharactersStore";
import { Title } from "./molecules/header";
import { SubTitle } from "./molecules/subtitle";
import ChooseStarDialog from "./SelectChild/chooseStarModal";
import useCharacterDetails from "./Characters/useCharacterDetails";
import useUserDetailsStore from "../store/UserStore";
import { Tooltip } from "antd";

export default function CharacterDetails() {
  const [
    formState,
    handleCharacterDetailsChange,
    addNewCharacter,
    deleteCharacter,
    story,
  ] = useAdvanceStoryStore((state) => [
    state.formState,
    state.handleCharacterDetailsChange,
    state.addNewCharacter,
    state.deleteCharacter,
    state.story,
  ]);
  const charactersElements = formState?.characters;
  const [showAddCharacterDialog, setShowAddCharacterDialog] =
    React.useState(false);
  const [setSelectedKidForCharacter, characters] = characterStore((state) => [
    state.setSelectedKidForCharacter,
    state.characters,
  ]);
  useCharacterDetails();
  const [deleteCharacterName, setDeleteCharactername] = useState(null);
  const [showCharacterListDialog, setShowCharacterListDialog] = useState(false);
  const handleDeleteCharacter = () => {
    deleteCharacter(deleteCharacterName);
    setDeleteCharactername(null);
  };
  const canAddCharacter = useUserDetailsStore((state) => state.canAddCharacter);

  return (
    <React.Fragment>
      <DialogWrapper
        isOpen={Boolean(deleteCharacterName)}
        onClose={() => setDeleteCharactername(null)}
        header={null}
      >
        <SubTitle>
          Do you want to delete character <strong>{deleteCharacterName}</strong>
          ?
        </SubTitle>
        <div className="w-full flex justify-center my-4">
          <TransparentButton
            handleButtonClick={() => setDeleteCharactername(null)}
            className={"mx-2"}
          >
            Cancel
          </TransparentButton>
          <TransparentButton
            handleButtonClick={handleDeleteCharacter}
            theme="red"
            className={"mx-2"}
          >
            Delete
          </TransparentButton>
        </div>
      </DialogWrapper>
      {charactersElements?.map((character, index) => (
        <ModernCollapsible
          key={character.name + index}
          title={`${character?.name} ${
            character?.is_ai_generated ? " ( AI Generated )" : ""
          }`}
          index={index}
          onDelete={() => {
            setDeleteCharactername(character.name);
          }}
          elementId={123}
        >
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "100%" },
            }}
            noValidate
            autoComplete="off"
          >
            <div className="flex flex-col gap-6 justify-center items-center">
              <TextFieldWithSpinner
                id="outlined-disabled"
                label={`${character?.name}'s Appearance`}
                name="appearance"
                multiline
                rows={4}
                value={character.appearance}
                maxLength={300}
                onChange={(e) => {
                  handleCharacterDetailsChange(e, character.name);
                }}
                loading={
                  formState[
                    PAGE_TEXT_LOADING_STATE[
                      SOCKET_OPERATIONS.STORY_CHARACTER_APPERANCE
                    ]
                  ]
                }
              />

              <TextFieldWithSpinner
                maxLength={300}
                id="outlined-disabled"
                label="Clothing"
                name="clothing"
                value={character.clothing}
                onChange={(e) => {
                  handleCharacterDetailsChange(e, character.name);
                }}
                multiline
                rows={4}
                loading={
                  formState[
                    PAGE_TEXT_LOADING_STATE[
                      SOCKET_OPERATIONS.PAGE_CHARACTER_CLOTHING_CHANGE
                    ]
                  ]
                }
              />
              <TextFieldWithSpinner
                id="outlined-disabled"
                label="Expression"
                value={character.expression}
                name="expression"
                maxLength={300}
                onChange={(e) => {
                  handleCharacterDetailsChange(e, character.name);
                }}
                loading={
                  formState[
                    PAGE_TEXT_LOADING_STATE[
                      SOCKET_OPERATIONS.PAGE_CHARACTER_EXPRESSION_CHANGE
                    ]
                  ]
                }
              />
            </div>
          </Box>
        </ModernCollapsible>
      ))}

      <div className="w-full flex justify-center sticky bottom-4">
        <TransparentButton
          // disabled={!canAddCharacter}
          handleButtonClick={() => {
            setShowCharacterListDialog(true);
          }}
          className=""
        >
          Choose New Character
        </TransparentButton>
      </div>
      <ChooseStarDialog
        headingTitle={"Add Character to current page"}
        proceedButtonText={"+ Add Character(s) to page"}
        show={showCharacterListDialog}
        onClose={() => {
          setShowCharacterListDialog(false);
        }}
        returnType="json"
        onAddCharacter={() => {
          setShowAddCharacterDialog(true);
          setShowCharacterListDialog(false);
        }}
        childList={characters}
        getStartedFn={(values) => {
          values.forEach((value) => {
            var data = {
              age: value.age,
              gender: value.gender,
              name: value.name,
              appearance: value.visual_description_plaintext,
              typical_expression: value.typical_expression,
              typical_clothing: value.typical_clothing,
            };
            addNewCharacter(data);
          });
          setShowCharacterListDialog(false);
        }}
      />
      <DialogWrapper
        isOpen={showAddCharacterDialog}
        onClose={() => {
          setShowAddCharacterDialog(false);
        }}
        header={
          <center className="pt-4">
            <Title className={""}>Add Character</Title>
          </center>
        }
      >
        <CharacterForm
          type={"other"}
          onClose={() => {
            setShowAddCharacterDialog(false);
          }}
          characterDetails={null}
          overrideOnSubmit={(values) => {
            addNewCharacter(values);
            setShowAddCharacterDialog(false);
          }}
        />
      </DialogWrapper>
    </React.Fragment>
  );
}
